export const AUTH_USER = "auth_user"
export const AUTH_USER_REQUEST = "auth_user_request"
export const UNAUTH_USER = "unauth_user"
export const AUTH_ERROR = "auth_error"
export const FETCH_MESSAGE = "fetch_message"
export const GET_VENUE_REQUEST = "get_venue_request"
export const GET_VENUE = "get_venue"
export const GET_VENUE_ERROR = "get_venue_error"
export const NEW_VENUE_REQUEST = "new_venue_request"
export const NEW_VENUE = "new_venue"
export const NEW_VENUE_ERROR = "new_venue_error"
export const UPDATE_VENUE_REQUEST = "update_venue_request"
export const UPDATE_VENUE = "update_venue"
export const UPDATE_VENUE_ERROR = "update_venue_error"
export const VENUE_LIST_REQUEST = "venue_list_request"
export const VENUE_LIST = "venue_list"
export const VENUE_LIST_ERROR = "venue_list_error"
export const GEO_REQUEST = "geo_request"
export const SAVE_VENUE = "save_venue"
export const NEW_EVENT_REQUEST = "new_event_request"
export const NEW_EVENT = "new_event"
export const NEW_EVENT_ERROR = "new_event_error"
export const EVENT_LIST_REQUEST = "event_list_request"
export const EVENT_LIST = "event_list"
export const EVENT_LIST_ERROR = "event_list_error"
export const GET_EVENT_REQUEST_LOAD = "get_event_request_load"
export const GET_EVENT_REQUEST_LOAD_SUCCESS = "get_event_request_load_success"
export const GET_EVENT_REQUEST = "get_event_request"
export const GET_EVENT_ERROR = "get_event_error"
export const GET_EVENT = "get_event"
export const UPDATE_EVENT_REQUEST = "update_event_request"
export const UPDATE_EVENT = "update_event"
export const UPDATE_EVENT_ERROR = "update_event_error"
export const DELETE_EVENT_REQUEST = "delete_event_request"
export const DELETE_EVENT = "delete_event"
export const DELETE_EVENT_ERROR = "delete_event_error"
export const NOTIFICATION_LIST_REQUEST = "notification_list_request"
export const NOTIFICATION_LIST = "notification_list"
export const NOTIFICATION_LIST_ERROR = "notification_list_error"
export const GET_NOTIFICATION_REQUEST = "get_notification_request"
export const GET_NOTIFICATION = "get_notification"
export const GET_NOTIFICATION_ERROR = "get_notification_error"
export const NEW_NOTIFICATION_REQUEST = "new_notification_request"
export const NEW_NOTIFICATION = "new_notification"
export const NEW_NOTIFICATION_CONFIRMATION = "new_notification_confirmation"
export const NEW_NOTIFICATION_ERROR = "new_notification_error"



/** WEBPACK FOOTER **
 ** ./src/actions/types.js
 **/